const C = { bg: "#111", border: "#1e1e1e", accent: "#e8700a", text: "#f5f5f5", dim: "#666", green: "#22c55e", red: "#ef4444" };

function VariationChip({ value }) {
  if (value == null) return null;
  const up = value >= 0;
  return (
    <span style={{
      display: "inline-flex", alignItems: "center", gap: 2,
      fontSize: 11, fontWeight: 700, padding: "2px 7px", borderRadius: 99,
      background: up ? "rgba(34,197,94,.12)" : "rgba(239,68,68,.12)",
      color: up ? C.green : C.red,
      border: `1px solid ${up ? "rgba(34,197,94,.25)" : "rgba(239,68,68,.25)"}`,
    }}>
      {up ? "▲" : "▼"} {Math.abs(value)}%
    </span>
  );
}

export function MetricCard({ label, value, sub, chip, accent, style }) {
  return (
    <div style={{
      background: C.bg, border: `1px solid ${C.border}`, borderRadius: 10,
      padding: "16px 18px", display: "flex", flexDirection: "column", gap: 6, ...style,
    }}>
      <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: "1.5px", color: C.dim, textTransform: "uppercase" }}>{label}</div>
      <div style={{ fontSize: 22, fontWeight: 700, color: accent ? C.accent : C.text, lineHeight: 1.1 }}>{value ?? "—"}</div>
      {(sub || chip != null) && (
        <div style={{ display: "flex", alignItems: "center", gap: 6, marginTop: 2 }}>
          {sub && <span style={{ fontSize: 11, color: C.dim }}>{sub}</span>}
          <VariationChip value={chip} />
        </div>
      )}
    </div>
  );
}
